export const languageFlags = {
  en: "🇬🇧",
  sv: "🇸🇪",
  fr: "🇫🇷",
  de: "🇩🇪",
  it: "🇮🇹",
  es: "🇪🇸",
  pt: "🇵🇹",
  nl: "🇳🇱",
  pl: "🇵🇱",
  ro: "🇷🇴",
  ru: "🇷🇺",
  tr: "🇹🇷",
  ar: "🇸🇦",
  hi: "🇮🇳",
  bn: "🇮🇳",
  te: "🇮🇳",
  ta: "🇮🇳",
  mr: "🇮🇳",
  gu: "🇮🇳",
  kn: "🇮🇳",
  ml: "🇮🇳",
  pa: "🇮🇳",
  ur: "🇵🇰",
  fa: "🇮🇷",
  zh: "🇨🇳",
  ja: "🇯🇵",
  ko: "🇰🇷",
  vi: "🇻🇳",
  th: "🇹🇭",
  id: "🇮🇩",
  ms: "🇲🇾",
  fil: "🇵🇭",
};
